import { validateEmail } from '../../core/helpers';

// Need to target .newsletter because 
export default () => {
  if ($('[data-subscribe-newsletter]').length) {
    // Klaviyo setup
    $(document).on('click', '[data-subscribe-newsletter]', (e) => {
      e.preventDefault();
      e.stopPropagation();

      let err = '';

      $('[data-newsletter-error]').empty().addClass('hide');
      const $input = $('.newsletter #k_id_email');

      if (!validateEmail($input.val())) {
        err = 'Please enter a valid email.';
      }

      if ($input.val() === '') {
        err = 'Please enter your email.';
      }
    
      // Submit to service
      if (err === '') {
        $input.attr('aria-invalid', false);
        $('.newsletter #email_signup').trigger('submit');
        $('.newsletter, .footer__newsletter').addClass('sent');
        $('.newsletter__success, .footer__newsletter-success').removeClass('hide');
      } else {
        $('[data-newsletter-error]').text(err).removeClass('hide');
        $input.attr('aria-invalid', true);
        $input[0].focus(); // Focus the input so user can correct it
      }
    });

    /*
    // Mailchimp setup
    $(document).on('click', '.newsletter #mc-embedded-subscribe', () => {
      let err = '';

      $('[data-newsletter-error]').empty().addClass('hide');

      if (!validateEmail($('.newsletter #mce-EMAIL').val())) {
        err = 'Please enter a valid email.';
      }

      if ($('.newsletter #mce-EMAIL').val() === '') {
        err = 'Please enter your email.';
      }
    
      // Submit to service
      if (err === '') {
        $('.newsletter #mc-embedded-subscribe-form').trigger('submit');
        $('.newsletter').addClass('sent');
        $('.newsletter__success').removeClass('hide');
      } else {
        $('[data-newsletter-error]').text(err).removeClass('hide');
      }
    });
    */
  }

  if ($('[data-subscribe-newsletter-footer]').length) {
    $(document).on('click', '[data-subscribe-newsletter-footer]', (e) => {
      e.preventDefault();
      e.stopPropagation();

      let err = '';

      $('[data-newsletter-error-footer]').empty().addClass('hide');
      const $input = $('.footer__newsletter #k_id_email_footer');

      if (!validateEmail($input.val())) {
        err = 'Please enter a valid email.';
      }

      if ($input.val() === '') {
        err = 'Please enter your email.';
      }
    
      // Submit to service
      if (err === '') {
        $input.attr('aria-invalid', false);
        $('.footer__newsletter #email_signup_footer').trigger('submit');
        $('.newsletter, .footer__newsletter').addClass('sent');
        $('.newsletter__success, .footer__newsletter-success').removeClass('hide');
      } else {
        $('[data-newsletter-error-footer]').text(err).removeClass('hide');
        $input.attr('aria-invalid', true);
        $input[0].focus(); // Focus the input so user can correct it
      }
    });

    // [ADA]
    $(document).on('keypress', '[data-subscribe-newsletter-footer]', (e) => {
      const key = e.which;
    
      // Enter / spacebar
      if (key === 13 || key === 32) {
        const $item = $(e.currentTarget);
        $item.trigger('click');
      }
    });
  }
};
